import { cropsTransformer } from './recipeHelpers'

export type Image = {
  crops: {
    url: string
    width: number
  }[]
  description: string | null
  title: string | null
  type: string
}

const mediaTransformer = (images: Image[], title: string) => {
  const imagesMap = images.map((image) => ({
    type: image.type,
    urls: cropsTransformer(image.crops),
    title: image.title || title,
    description: image.description,
  }))

  return imagesMap
}

export { mediaTransformer }
